import React, { useEffect, useState } from 'react';
import { Plus, X } from 'lucide-react';
import api from '../api';
import { useToast } from '../context/ToastContext';
import { Modal, Button } from './ui';

/** Gestione "voce del brand" di un cliente: tono, parole vietate, set di hashtag, snippet. */
export default function VoceBrandModal({ open, clienteId, onClose, onSaved }) {
  const { success } = useToast();
  const [v, setV] = useState(null);
  const [vietate, setVietate] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open || !clienteId) return;
    api.get(`/voce/${clienteId}`).then(r => {
      setV({ tono: r.data.tono || '', hashtag_set: r.data.hashtag_set || [], snippet: r.data.snippet || [] });
      setVietate((r.data.parole_vietate || []).join(', '));
    }).catch(() => {});
  }, [open, clienteId]);

  const salva = async () => {
    setSaving(true);
    try {
      const r = await api.put(`/voce/${clienteId}`, {
        tono: v.tono, parole_vietate: vietate.split(',').map(x => x.trim()).filter(Boolean),
        hashtag_set: v.hashtag_set.filter(x => x.nome.trim()), snippet: v.snippet.filter(x => x.nome.trim()),
      });
      success('Voce del brand salvata');
      onSaved && onSaved(r.data);
      onClose();
    } catch { /* toast globale */ }
    setSaving(false);
  };

  const lab = (t) => <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-muted)', margin: '14px 0 6px' }}>{t}</div>;
  const lista = (key, campo, ph1, ph2) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {v[key].map((x, i) => (
        <div key={i} style={{ display: 'flex', gap: 6, alignItems: 'flex-start' }}>
          <input className="eden-input" value={x.nome} placeholder={ph1} style={{ width: 130, flexShrink: 0 }}
            onChange={e => setV(s => ({ ...s, [key]: s[key].map((y, j) => j === i ? { ...y, nome: e.target.value } : y) }))} />
          <textarea className="eden-input" value={x[campo]} placeholder={ph2} style={{ minHeight: 38, resize: 'vertical' }}
            onChange={e => setV(s => ({ ...s, [key]: s[key].map((y, j) => j === i ? { ...y, [campo]: e.target.value } : y) }))} />
          <button onClick={() => setV(s => ({ ...s, [key]: s[key].filter((_, j) => j !== i) }))}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-dim)', padding: 8 }}><X size={14} /></button>
        </div>
      ))}
      <button onClick={() => setV(s => ({ ...s, [key]: [...s[key], { nome: '', [campo]: '' }] }))}
        style={{ alignSelf: 'flex-start', display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12, padding: '5px 10px', borderRadius: 7, border: '1px dashed var(--border)', background: 'transparent', color: 'var(--text-muted)', cursor: 'pointer' }}>
        <Plus size={12} /> Aggiungi
      </button>
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} title="Voce del brand" width={640}
      footer={<><Button onClick={onClose}>Annulla</Button><Button variant="primary" loading={saving} onClick={salva} disabled={!v}>Salva</Button></>}>
      {!v ? <div style={{ color: 'var(--text-dim)', fontSize: 13 }}>Caricamento…</div> : (
        <>
          {lab('Tono di voce')}
          <textarea className="eden-input" value={v.tono} onChange={e => setV(s => ({ ...s, tono: e.target.value }))}
            placeholder="es. Diretto e caldo, dai del tu, niente superlativi, emoji con moderazione" style={{ minHeight: 60, resize: 'vertical' }} />
          {lab('Parole da evitare (separate da virgola)')}
          <input className="eden-input" value={vietate} onChange={e => setVietate(e.target.value)} placeholder="es. economico, sconto, cheap" />
          {lab('Set di hashtag')}
          {lista('hashtag_set', 'tags', 'Nome set', '#brand #prodotto #città')}
          {lab('Snippet (CTA, firme, disclaimer)')}
          {lista('snippet', 'testo', 'Nome', 'es. Prenota ora dal link in bio 👆')}
        </>
      )}
    </Modal>
  );
}
